import { useState, useEffect } from "react";
import advService from "../advService";
import { GET_EMPLOYEE_SUPPORT_GET } from "../newconfig";

interface SupportContact {
    name: string;
    level: string;
    phone: string;
    email: string;
}

interface SupportData {
    broker: SupportContact[];
    tpa: SupportContact[];
    insurer: SupportContact[];
}

export const useHelpContactData = () => {
    const [hasData, setHasData] = useState<boolean | null>(null);
    const [loading, setLoading] = useState(false);

    const checkDataAvailability = () => {
        setLoading(true);
        advService(GET_EMPLOYEE_SUPPORT_GET, {}, (response: any) => {
            try {
                if (response.data.success) {
                    const supportData: SupportData = response.data.response;

                    const hasValidData = Object.values(supportData).some(
                        (contacts) =>
                            contacts &&
                            contacts.some(
                                (contact: SupportContact) =>
                                    contact.name && contact.name.trim() !== ""
                            )
                    );

                    setHasData(hasValidData);
                } else {
                    setHasData(false);
                }
            } catch (error) {
                console.error("Error processing support data:", error);
                setHasData(false);
            } finally {
                setLoading(false);
            }
        });
    };

    useEffect(() => {
        checkDataAvailability();
    }, []);

    return { hasData, loading, refetch: checkDataAvailability };
};
